import { render, staticRenderFns } from "./NotEditable.vue?vue&type=template&id=40282630&"
import script from "./NotEditable.vue?vue&type=script&lang=js&"
export * from "./NotEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40282630')) {
      api.createRecord('40282630', component.options)
    } else {
      api.reload('40282630', component.options)
    }
    module.hot.accept("./NotEditable.vue?vue&type=template&id=40282630&", function () {
      api.rerender('40282630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/NotEditable.vue"
export default component.exports